import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { YearContextForm } from "../../components/yearContext/YearContextForm";
import { getYearString } from "../../helpers/stringHelper";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { YearContext } from "../../models/yearContext";
import { year_context_path, year_contexts_path } from "../../routes";

type YearContextEditProps = {
  year: YearContext;
};

export default function YearContextEdit({ year }: YearContextEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(year_context_path, year.id), values);

  return (
    <ContentShell
      title={`Jahrgang ${getYearString(year)}`}
      pageTitle={`Jahrgang ${getYearString(year)} bearbeiten`}
      onBack={() => router.get(pathWithYearContext(year_contexts_path))}
    >
      <YearContextForm year={year} onSubmit={onSubmit} submitButtonLabel="Speichern" />
    </ContentShell>
  );
}
